import { createRoot } from 'react-dom/client';
import ReportsApp from '../ReportsApp.jsx'; // Only import ReportsApp here

const initHavenlyticsAdminReports = () => {
  const container = document.getElementById('HvnlyNab_reports_analytics_render');
  if (!container) return;

  const root = createRoot(container);
  root.render(<ReportsApp />);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHavenlyticsAdminReports);
} else {
  initHavenlyticsAdminReports();
}

export default initHavenlyticsAdminReports;
